import React, { forwardRef, ForwardedRef, ChangeEvent } from 'react';

interface HiddenFileInputProps {
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

function HiddenFileInput({
  handleChange,
  ...props
}: HiddenFileInputProps, ref: ForwardedRef<HTMLInputElement>) {
  return (
    <input
      type={'file'}
      ref={ref}
      style={{
        display: 'none',
      }}
      multiple
      onChange={handleChange}
      {...props}
    />
  );
}

export default forwardRef(HiddenFileInput);
